import styled from "styled-components";

export const AppFigureWrapper = styled.div`
  background-image: url("/img/line-bg.png");
  min-height:25rem;
`

